module.exports = __webpack_public_path__ + "img/product1.d5d3bd99.png";